class CartItem extends HTMLElement {
  connectedCallback() {
    this.cartItemLine = this.dataset.lineItemIndex;
    this.cartItemProductId = Number(this.dataset.lineItemProductId) || null;
    this.loadingOverlay = this.querySelector('.loading-overlay');

    this.unsubscribeCartUpdating = subscribe('cart:updating', ({ line }) =>
      this.toggleLoading(line, true)
    );
    this.unsubscribeCartError = subscribe('cart:error', ({ line }) =>
      this.toggleLoading(line, false)
    );

    this.addEventListener('click', (event) => {
      if (!event.target.closest('[data-line-item-remove]')) return;
      event.preventDefault();
      publish('cart:change', {
        line: this.cartItemLine,
        quantity: 0,
        productId: this.cartItemProductId,
      });
    });
  }

  disconnectedCallback() {
    this.unsubscribeCartUpdating();
    this.unsubscribeCartError();
  }

  /**
   * Toggle the loading overlay.
   * @param {boolean} isLoading - Whether to show or hide the loading overlay.
   */
  toggleLoading(line, isLoading) {
    if (line !== this.cartItemLine) return;
    this.loadingOverlay.ariaHidden = !isLoading;
  }
}

customElements.define('line-item', CartItem);
